import request from '../../library/request';
import {MESSAGE_TYPES} from '../../pages/branding/menu/brandingConfig';
import store from '../../store';
import setGlobalState from '../setGlobalState';
import {serializeTemplateStructure} from '../../component/whatsAppTemplateEditor/utils/formatUtils';
import {getState} from '../store.type';
import {uploadFile} from '../user/userActions';
import {wrapXHR} from '../../functions/wrapXHR';

const getEid = () => store.getState().event.eid || store.getState().crm.contextEid;

export const updateDesignEmail = (messageType, data) =>
    wrapXHR('branding.updateDesignEmailFullXHR', async () => {
        const eid = getEid();
        if(data.imageMain?.image){data.imageMain.image = await uploadFile(data.imageMain.image, '', 'designEmail', eid);}
        const lang = store.getState().branding?.currentLang || store.getState().event.lang || 'he';
        const res = await request('branding.updateDesignEmail', 'put', `/event/${eid}/designEmail`, {messageType, data, lang});
        setGlobalState(`branding.data.${lang}.${messageType}`, {...store.getState().branding.data[lang]?.[messageType], ...res});
        setGlobalState('branding.previewKey', store.getState().branding.previewKey + 1);
    });

export const updateDesignTicket = async (data) => {
    const eid = getEid();
    const lang = store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request('branding.updateDesignTicket', 'put', `/event/${eid}/designTicket`, data);
    setGlobalState(`branding.data.${lang}`, {...store.getState().branding.data[lang], ...res});
};

export const getEmailData = async () => {
    const lang=store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request(`branding.getBrandingData.${lang}`, 'get', `/event/${getEid()}/branding`,{lang});
    const branding =store.getState().branding;
    setGlobalState('branding', {...branding, ...res.data, data: {...branding.data, [lang]: res.commonData}});
};
export const getEmailPreview = async (emailContent, messageType) => {
    const lang=store.getState().branding.currentLang;
    const res = await request('branding.getEmailPreview', 'get', `/event/${getEid()}/brandingPreview`,{lang,emailContent,messageType});
    return res.html;
};

export const updateEmailStatus = async (field, value, messageType) => {
    const lang=store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request('branding.updateEmailStatus', 'put', `/event/${getEid()}/designEmailStatus`, {lang,field,value,messageType});
    if([MESSAGE_TYPES.desperate, MESSAGE_TYPES.billing].includes(messageType)) {
        setGlobalState(`branding.data.${lang}.${messageType}`, {...store.getState().branding.data[lang]?.[messageType],...res});
    }
    if(field==='enabledWhatsapp'){
        const currentMessageTypeData = store.getState().branding.data[lang]?.[messageType] || {};
        setGlobalState(`branding.data.${lang}.${messageType}`, {...currentMessageTypeData, ...res});
    }
    else {
        setGlobalState(`branding.data.${lang}`, {...store.getState().branding.data[lang],...res});
    }
};

export const saveWhatsAppImage = (imageData, messageType) =>
    wrapXHR('branding.saveWhatsAppImageFullXHR', async () => {
        const eid = getEid();
        const lang = getState().branding?.currentLang || 'he';

        if(imageData?.image){imageData.image = await uploadFile(imageData.image, 'image/png', 'whatsappImage', eid);}
        const res = await request('branding.saveWhatsAppImage', 'put', `/event/${eid}/whatsappMessage`, {imageData, lang});
        if(res?.whatsappImage){
            const messageData = {...getState().branding.data[lang]?.[messageType], whatsappImage: res.whatsappImage};
            setGlobalState('branding', {...getState().branding, ...res.data, data: {...getState().branding.data, [lang]: {...getState().branding.data[lang], [messageType]: messageData}}});
        }
    });

export const updateWhatsAppMessage = async (message, messageType, inlineParams = null) => {
    const eid = getEid();
    const lang= getState().branding?.currentLang || 'he';
    const payload = {message, lang, messageType, ...(inlineParams && {inlineParams})};
    
    const res = await request('branding.updateWhatsAppMessage', 'put', `/event/${eid}/whatsappMessage`, payload);
    const branding = getState().branding;
    const messageData = {
        ...branding.data[lang]?.[messageType],
        whatsappMessage: res.message,
        whatsappImage: res.image,
        whatsappContent: res.whatsappContent,
    };
    setGlobalState('branding', {...branding, ...res.data, data: {...branding.data, [lang]: {...branding.data[lang], [messageType]: messageData}}});
};

export const saveFreeWhatsAppMessage = async (message, messageType, source) => {
    const eid = getEid();
    const lang = getState().branding?.currentLang || 'he';
    const res = await request('branding.saveFreeWhatsAppMessage', 'put', `/event/${eid}/freeWhatsappMessage`, {
        message,
        lang,
        messageType,
        ...(source != null && source !== '' && {source}),
    });
    if(!res) {
        return null;
    }
    if(source) { // For mailing (crm, lead)
        setGlobalState(`mailing.designMailing.${source}`, res);
    }
    else { // For ticket branding
        const branding = getState().branding;
        const messageData = {
            ...branding.data[lang]?.[messageType],
            ...(res.message !== undefined && {whatsappMessage: res.message}),
            ...(res.image !== undefined && {whatsappImage: res.image}),
            ...(res.whatsappContent !== undefined && {whatsappContent: res.whatsappContent}),
        };
        setGlobalState('branding', {...branding, ...res.data, data: {...branding.data, [lang]: {...branding.data[lang], [messageType]: messageData}}});
        return res.whatsappContent;
    }
};

export const sendWhatsAppTemplateTrial = async (data) => {
    const eid = getEid();
    const res = await request('branding.sendWhatsAppTemplateTrial', 'post', `/event/${eid}/whatsappTicketTrial`, {...data});
    return res;
};
export const getWhatsappTemplate = async (type) => {
    const res = await request('branding.getWhatsappTemplate', 'get', `/event/${getEid()}/whatsappTemplate`, {type});
    if(res?.whatsappMessage)
        setGlobalState(`branding.${type}WhatsappTemplate`, res.whatsappMessage);
};

// AI Draft
export const getWhatsAppAIDraft = async (prompt, messageType, history = [], sessionId, feature) => {
    const eid = getEid();
    const lang = store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request(
        'branding.getWhatsAppAIDraft',
        'post',
            `/event/${eid}/whatsappMessage/aiDraft`,
            {prompt, lang, messageType, history, sessionId, feature},
            {handleError: true}
    );
    if(!Array.isArray(res?.parameterValues) || !res.parameterValues.length) {
        return null;
    }
    return {
        text: serializeTemplateStructure(res.parameterValues),
        parameterValues: res.parameterValues,
    };
};